module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Vuks er feil.9cac0e22.mp3";